import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import TheApp from "./components/app/App";
import Spinner from "./components/Spinner";
import ScrollToTop from "./ScrollTop";

const Home = lazy(() => import("./components/home/Home"));
const PrivacyPolicy = lazy(() => import("./components/content/PrivacyPolicy"));
const TermsCondition = lazy(() => import("./components/content/TermsCondition"));
const Faqs = lazy(() => import("./components/faqs/Faqs"));
const HowWorks = lazy(() => import("./components/howWorks/HowWorks"));
const ContactUs = lazy(() => import("./components/contactus/ContactUs"));
const Blog = lazy(() => import("./components/blog/Blog"));
const BlogDetails = lazy(() => import("./components/blog/BlogDetails"));
const Aboutus = lazy(() => import("./components/about/Aboutus"));

function App() {
  return (
    <Router >
      <ScrollToTop />
      <Header />

      <Suspense fallback={<div className="text-center p-10"><Spinner /></div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/how-it-works" element={<HowWorks />} />
          <Route path="/app" element={<TheApp />} />

          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blog-detail/:id" element={<BlogDetails />} />
          <Route path="/about-us" element={<Aboutus />} />
          <Route path="/*" element={<Navigate to="/" replace />} />   
          </Routes>
      </Suspense>

      <Footer />
    </Router>
  );
}

export default App;

